// importar tudo o que quiseres e exportar num array ou objeto
import facebook from "./Facebook.svg";
import linkedin from "./LinkedIn.svg";
import youtube from "./Youtube.svg";
import instagram from "./Instagram.svg";

export const socialNetworkImages = [facebook, linkedin, youtube, instagram];

// ou com nomes:
export const namedImages = {
  first: facebook,
  second: linkedin,
  third: youtube,
  fourth: instagram,
};

export const socialNetworkData = [
  {
    name: "Facebook",
    link: "https://www.facebook.com/mafirol/",
    image: facebook,
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/company/grupo-mafirol/",
    image: linkedin,
  },
  {
    name: "Youtube",
    link: "https://www.youtube.com/@GrupoMAFIROL",
    image: youtube,
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/grupomafirol/",
    image: instagram,
  },
];
